// extracted by mini-css-extract-plugin
export default {"date":"PublishedDate-module__date--stFLY"};